// extracted by mini-css-extract-plugin
export default {"buttonContainer":"DomainKeys_buttonContainer_XErWl","tableContainer":"DomainKeys_tableContainer_B5bpH"};